import { DC_TYPE, FLUID_TYPE, PGN, PGN_VALUE, TEMP_TYPE } from "./consts"

export type PgnNumber = typeof PGN[keyof typeof PGN]

export interface Timestamped {
  T: number // unix timestamp
}

export interface PgnGnssData1 extends Timestamped {
  [PGN_VALUE.LXM_IOT_GNSS_DATA_1__LAT]: number, // latitude
  [PGN_VALUE.LXM_IOT_GNSS_DATA_1__LON]: number  // longitude
}

export interface PgnGnssData2 extends Timestamped {
  [PGN_VALUE.LXM_IOT_GNSS_DATA_2__COG]: number, // course over ground
  [PGN_VALUE.LXM_IOT_GNSS_DATA_2__SOG]: number  // speed over ground
}

export interface PgnEngineData1 extends Timestamped {
  [PGN_VALUE.LXM_IOT_ENGINE_DATA_1__RPM]: number,      // engine RPM
  [PGN_VALUE.LXM_IOT_ENGINE_DATA_1__FUEL_RATE]: number // engine fuel rate
}

export interface PgnEngineData2 extends Timestamped {
  [PGN_VALUE.LXM_IOT_ENGINE_DATA_2__TEMP]: number, // engine temperature
  [PGN_VALUE.LXM_IOT_ENGINE_DATA_2__TRIM]: number  // engine trim
}

export interface PgnDcStatus1 extends Timestamped {
  [PGN_VALUE.LXM_IOT_DC_STATUS_1__SOC]: number, // state of charge
  [PGN_VALUE.LXM_IOT_DC_STATUS_1__SOH]: number, // state of health
  [PGN_VALUE.LXM_IOT_DC_STATUS_1__TEMP]: number // battery temperature
}

export interface PgnDcStatus2 extends Timestamped {
  [PGN_VALUE.LXM_IOT_DC_STATUS_2__A]: number,   // Current
  [PGN_VALUE.LXM_IOT_DC_STATUS_2__V]: number,   // Voltage
  [PGN_VALUE.LXM_IOT_DC_STATUS_2__TRM]: number, // Estimated time remaining
  [PGN_VALUE.LXM_IOT_DC_STATUS_2__RNG]: number  // Estimated range
}

export interface PgnFluid extends Timestamped {
  [PGN_VALUE.LXM_IOT_FLUID__LVL]: number // Fluid level
}

export interface PgnTemperature extends Timestamped {
  [PGN_VALUE.LXM_IOT_TEMPERATURE__TEMP]: number // Temperature
}

export interface PgnWaterDepth extends Timestamped {
  [PGN_VALUE.LXM_IOT_WATER_DEPTH__DEPTH]: number // Water depth
}

export interface PgnWRefSpeed extends Timestamped {
  [PGN_VALUE.LXM_IOT_WREF_SPD__SPD]: number // Water referenced speed
}

export interface PgnRudder extends Timestamped {
  [PGN_VALUE.LXM_IOT_RUDDER__POS]: number // Rudder position
}

export type PgnData = PgnGnssData1
  | PgnGnssData2
  | PgnEngineData1
  | PgnEngineData2
  | PgnDcStatus1
  | PgnDcStatus2
  | PgnFluid
  | PgnTemperature
  | PgnWaterDepth
  | PgnWRefSpeed
  | PgnRudder

export type DcType = typeof DC_TYPE[keyof typeof DC_TYPE]
export type FluidType = typeof FLUID_TYPE[keyof typeof FLUID_TYPE]
export type TemperatureType = typeof TEMP_TYPE[keyof typeof TEMP_TYPE]

export interface DcMetaData {
  DCTypeID: DcType
}

export interface FluidMetaData {
  FluidTypeID: FluidType
}

export interface TemperatureMetaData {
  TempTypeID: TemperatureType
}

export const TankCapacity = "TankCapacity"
export interface TankMetaData {
  [TankCapacity]: number
}

export type MetaData = DcMetaData | FluidMetaData | TemperatureMetaData | TankMetaData

export interface PgnMetaData {
  PGN: PgnNumber,
  MetaData: MetaData
}